<template>
    <div class="maintenanceRecordBox">
        <div class="head">
            <el-button type="primary" size="small" @click="addEquipmentBtn">添加设备</el-button>
        </div>
        <div class="bodyBox">
            <div class="bodyLeft">
                <div class="leftTitle">
                    <div>分类</div>
                    <i class="el-icon-plus" style="padding-top: 2px;cursor: pointer" @click="addClass"></i>
                </div>
                <!-- 左边的导航栏 -->
                <div class="leftBody">
                    <Menu theme="light" :active-name="checkType" accordion ref="menu" @on-select="selectType">
                        <MenuItem :name="item.id" v-for="item in typeArr" :key="item.id"
                                  style="display:flex;justify-content: space-between;">
                            <span class="menuitem">{{ item.name }}</span>
                            <div @click.stop>
                                <el-popconfirm :hide-icon="true" v-if="checkType === item.id" confirm-button-text="编辑"
                                               cancel-button-text="删除"
                                               cancel-button-type="danger"
                                               @onConfirm="editClass"
                                               @onCancel="delectClass">
                                    <Icon type="md-menu" size="18" slot="reference"/>
                                </el-popconfirm>
                            </div>
                        </MenuItem>
                    </Menu>
                </div>
                <div class="leftFoot">
                    <div class="leftTitle">
                        <div>设备统计</div>
                    </div>
                    <div>在用数：{{ statisticsObj.useCount }}</div>
                    <div>完好数量：{{ statisticsObj.intactCount }}</div>
                    <div>停用数量：{{ statisticsObj.stopUseCount }}</div>
                    <div>维修中数量：{{ statisticsObj.maintainCount }}</div>
                    <div>报废数量：{{ statisticsObj.scrapCount }}</div>
                    <div>过期数量：{{ statisticsObj.pastDueCount }}</div>
                </div>
            </div>
            <div class="bodyRight">
                <!-- 表格 -->
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%">
                    <el-table-column
                            label="装置设施位号">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="openDrawer(scope.row)">{{ scope.row.number }}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="装置设施名称">
                    </el-table-column>
                    <el-table-column
                            prop="bugTime"
                            label="购买日期">
                        <template slot-scope="{ row }">
                            <span v-if="row.bugTime">{{ row.bugTime | timeFilter }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="durableYears"
                            label="使用期限">
                    </el-table-column>
                    <el-table-column
                            prop="expirationTime"
                            label="到期日期">
                        <template slot-scope="{ row }">
                            <span v-if="row.expirationTime">{{ row.expirationTime | timeFilter }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column
                      prop="nextKeepTime"
                      label="下次维护养护时间">
                      <template slot-scope="{ row }">
                        <span v-if="row.nextKeepTime">{{ row.nextKeepTime | timeFilter }}</span>
                      </template>
                    </el-table-column> -->
                    <el-table-column
                            label="操作">
                        <template slot-scope="scope">
                            <el-link :underline="false" type="primary" @click="editEquipmentBtn(scope.row)">编辑
                            </el-link>
                            <span class="line">|</span>
                            <el-link :underline="false" type="primary" @click="examinBtn(scope.row, 1)"
                                     v-if="scope.row.isExamine">检查
                            </el-link>
                            <span class="line" v-if="scope.row.isExamine">|</span>
                            <el-link :underline="false" type="primary" @click="examinBtn(scope.row, 2)"
                                     v-if="scope.row.isDetection">检测
                            </el-link>
                            <span class="line" v-if="scope.row.isDetection">|</span>
                            <el-link :underline="false" type="primary" @click="operationBtn(scope.row)">操作</el-link>
                            <span class="line">|</span>
                            <el-link :underline="false" type="danger" @click="deleteEquipmentBtn(scope.row)">删除
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 设备列表分页 -->
                <div style="text-align: right;margin-top: 15px">
                    <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="totalType" :page-size="limitType" :current-page="curPageType"
                            @current-change="curPageChange1">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 右边的抽屉 -->
        <el-drawer :visible.sync="drawer" direction="rtl" :before-close="handleClose"
                   size="70%" :show-close="false">
            <div slot="title" class="drawerTitle">
                <p>装置设施名称：{{ detailObj.name }}
                    <i @click="handleClose" class="el-icon-circle-close"></i>
                </p>
                <div class="tWord">
                    <div><p>装置设施位号</p><span>{{ detailObj.number }}</span></div>
                    <div><p>装置设施型号</p><span>{{ detailObj.typeSpecification }}</span></div>
                    <div><p>单位部门</p><span>{{ detailObj.depName }}</span></div>
                    <div><p>生产日期</p><span>{{ detailObj.dateInProduced }}</span></div>
                    <div><p>使用期限</p><span>{{ detailObj.durableYears }}月</span></div>
                </div>
            </div>
            <div class="drawerBody">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="详情" name="0"></el-tab-pane>
                    <el-tab-pane label="巡检记录" name="1"></el-tab-pane>
                    <el-tab-pane label="保养维修记录" name="2"></el-tab-pane>
                    <el-tab-pane label="检查记录" name="3"></el-tab-pane>
                    <el-tab-pane label="检测记录" name="4"></el-tab-pane>
                    <el-tab-pane label="操作记录" name="5"></el-tab-pane>
                </el-tabs>
                <div class="bodyInner">
                    <!-- 详情 -->
                    <div v-show="activeName === '0'" class="detailBox">
                        <div class="detail">
                            <div>装置设施名称：<span>{{ detailObj.name }}</span></div>
                            <div>装置设施位号：<span>{{ detailObj.number }}</span></div>
                            <div>装置设施用途：<span>{{ detailObj.purpose }}</span></div>
                            <div>装置设施型号：<span>{{ detailObj.typeSpecification }}</span></div>
                            <div>类型/类别：<span>{{ detailObj.equipmentTypeId }}</span></div>
                            <div>单位部门：<span>{{ detailObj.depName }}</span></div>
                            <div>设置部位：<span>{{ detailObj.location }}</span></div>
                            <div>生产日期：<span>{{ detailObj.dateInProduced | timeFilter }}</span></div>
                            <div>使用期限：<span>{{ detailObj.durableYears }}月</span></div>
                            <div>生命周期：<span>{{ detailObj.lifeCycle === 1 ? '已投用' : '报废' }}</span></div>
                            <div>购买日期：<span>{{ detailObj.bugTime | timeFilter }}</span></div>
                            <div>投用日期：<span>{{ detailObj.serviceDate | timeFilter }}</span></div>
                            <div>维修状态：<span>{{ detailObj.maintainStatus === 1 ? '完好' : '维修中' }}</span></div>
                            <div>停用状态：<span>{{ detailObj.serviceStatus === 0 ? '停用' : '在用' }}</span></div>
                            <div>上次检查日期：<span>{{ detailObj.lastExamineTime | timeFilter }}</span></div>
                            <div>上次检测日期：<span>{{ detailObj.lastDetectionTime | timeFilter }}</span></div>
                            <div>上次保养日期：<span>{{ detailObj.lastKeepTime | timeFilter }}</span></div>
                            <div>下次检查日期：<span>{{ detailObj.nextExamineTime | timeFilter }}</span></div>
                            <div>下次检测日期：<span>{{ detailObj.nextDetectionTime | timeFilter }}</span></div>
                            <div>下次保养日期：<span>{{ detailObj.nextKeepTime | timeFilter }}</span></div>
                            <div>负责人部门：<span>{{ detailObj.chargeDepName }}</span></div>
                            <div>负责人：<span>{{ detailObj.chargeUserName }}</span></div>
                            <div>供应商：<span>{{ detailObj.supplier }}</span></div>
                            <div>使用说明：
                                <el-link type="primary"
                                         @click="downloadFile(detailObj.instructionsUrl, detailObj.instructionsName)">
                                    {{ detailObj.instructionsName }}
                                </el-link>
                            </div>
                            <div>是否检查：<span>{{ detailObj.isExamine === 0 ? '否' : '是' }}</span></div>
                            <div>检查周期：<span>{{ detailObj.examineCycle }}天</span></div>
                            <div>检查提前提醒：<span>{{ detailObj.examineAdvanceData }}天</span></div>
                            <div>检查指标：<span>{{ detailObj.examineIndicator }}</span></div>
                            <div>预警值：<span>{{ detailObj.prewarningValue }}</span></div>
                            <div>联锁值：<span>{{ detailObj.interlockingValue }}</span></div>
                            <div>检查部门：<span>{{ detailObj.examineDepName }}</span></div>
                            <div>是否检测：<span>{{ detailObj.isDetection === 0 ? '否' : '是' }}</span></div>
                            <div>检测周期：<span>{{ detailObj.detectionCycle }}天</span></div>
                            <div>检测提前提醒：<span>{{ detailObj.detectionAdvanceData }}天</span></div>
                            <div>检测部门：<span>{{ detailObj.detectionDepName }}</span></div>
                            <div>是否维修/保养：<span>{{ detailObj.isKeep === 0 ? '否' : '是' }}</span></div>
                        </div>
                    </div>
                    <!-- 巡检记录 -->
                    <div class="detailBox" v-show="activeName === '1'">
                        <el-date-picker
                                v-model="timeRange"
                                type="daterange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                size="small"
                                style="margin-right: 15px"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                        <el-button size="small" type="primary" @click="openFullDia">预览/打印</el-button>
                        <el-table
                                :data="tableData2"
                                border
                                style="width: 100%; margin-top: 10px">
                            <el-table-column
                                    prop="number"
                                    label="编号">
                            </el-table-column>
                            <el-table-column
                                    prop="name"
                                    label="名称">
                            </el-table-column>
                            <el-table-column
                                    label="异常状态">
                                <template slot-scope="scope">
                                    <el-tag type="success" effect="dark" v-if="scope.row.error_status === 0"
                                            size="small">无异常
                                    </el-tag>
                                    <el-tag type="danger" effect="dark" v-if="scope.row.error_status === 1"
                                            size="small">有异常
                                    </el-tag>
                                    <span v-else></span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="start_time"
                                    label="开始时间">
                            </el-table-column>
                            <el-table-column
                                    prop="finish_time"
                                    label="完成时间">
                            </el-table-column>
                            <el-table-column
                                    label="巡检人">
                                <template slot-scope="scope">
                                    <el-tag size="mini" style="margin-right: 5px"
                                            v-for="item in scope.row.checkingPeoples" :key="item.userId">
                                        {{ item.name }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="status"
                                    label="状态">
                                <template slot-scope="scope">
                                    <el-tag type="danger" effect="plain" v-if="scope.row.status === 0" size="small">
                                        待巡检
                                    </el-tag>
                                    <el-tag type="success" effect="plain" v-if="scope.row.status === 1" size="small">
                                        已巡检
                                    </el-tag>
                                    <span v-else></span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 分页 -->
                        <div style="margin-top: 10px;text-align:right;padding-right: 18px">
                            <el-pagination
                                    background @current-change="curPageChange2"
                                    layout="prev, pager, next"
                                    :total="total2" :page-size="limit2" :current-page="curPage2">
                            </el-pagination>
                        </div>
                    </div>
                    <!-- 保养维修记录 -->
                    <div class="detailBox" v-show="activeName === '2'">
                        <el-table :data="tableData3" border style="width: 100%">
                            <el-table-column prop="number" label="编号"/>
                            <el-table-column prop="name" label="名称"/>
                            <el-table-column prop="equipmentName" label="设备"/>
                            <el-table-column prop="type" label="工作类型">
                                <template slot-scope="{ row }">
                                    {{ row.type === 1 ? "维修" : "保养" }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="start_time" label="开始时间"/>
                            <el-table-column prop="end_time" label="结束时间"/>
                            <el-table-column prop="status" label="状态">
                                <template slot-scope="{ row }">
                                    <!-- {{ row.status === 0 ? "未完成" : "已完成" }} -->
                                    <el-tag v-if="row.status === 0" type="danger">未完成</el-tag>
                                    <el-tag v-if="row.status === 1" type="success">已完成</el-tag>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 分页 -->
                        <div style="margin-top: 10px;text-align:right;padding-right:18px">
                            <el-pagination
                                    background @current-change="curPageChange3"
                                    layout="prev, pager, next"
                                    :total="total3" :page-size="limit3" :current-page="curPage3">
                            </el-pagination>
                        </div>
                    </div>
                    <!-- 检查记录 -->
                    <div class="detailBox" v-show="activeName === '3'">
                        <el-table :data="tableData4" border style="width: 100%">
                            <el-table-column prop="examineContent" label="检查内容"/>
                            <el-table-column prop="gmtCreate" label="检查时间"/>
                            <el-table-column prop="examineResult" label="检查结果"/>
                            <el-table-column prop="examineStatus" label="检查状态"/>
                            <el-table-column prop="examineUserName" label="检查人"/>
                        </el-table>
                        <!-- 分页 -->
                        <div style="margin-top: 10px;text-align:right;padding-right:18px">
                            <el-pagination
                                    background @current-change="curPageChange4"
                                    layout="prev, pager, next"
                                    :total="total4" :page-size="limit4" :current-page="curPage4">
                            </el-pagination>
                        </div>
                    </div>
                    <!-- 检测记录 -->
                    <div class="detailBox" v-show="activeName === '4'">
                        <el-table :data="tableData5" border style="width: 100%">
                            <el-table-column prop="detectionContent" label="检测内容"/>
                            <el-table-column prop="gmtCreate" label="检测时间"/>
                            <el-table-column prop="detectionResult" label="检测结果"/>
                            <el-table-column prop="detectionStatus" label="检测状态"/>
                            <el-table-column prop="detectionUserName" label="检测人"/>
                        </el-table>
                        <!-- 分页 -->
                        <div style="margin-top: 10px;text-align:right;padding-right:18px">
                            <el-pagination
                                    background @current-change="curPageChange5"
                                    layout="prev, pager, next"
                                    :total="total5" :page-size="limit5" :current-page="curPage5">
                            </el-pagination>
                        </div>
                    </div>
                    <!-- 操作记录 -->
                    <div class="detailBox" v-show="activeName === '5'">
                        <el-table :data="tableData6" border style="width: 100%">
                            <el-table-column prop="operationType" label="分类"/>
                            <el-table-column prop="reality" label="原因"/>
                            <el-table-column prop="operationTime" label="申请时间">
                                <template slot-scope="{ row }">{{ row.operationTime | timeFilter }}</template>
                            </el-table-column>
                            <el-table-column prop="realTime" label="真实时间">
                                <template slot-scope="{ row }">{{ row.realTime | timeFilter }}</template>
                            </el-table-column>
                            <el-table-column prop="measures" label="措施"/>
                            <el-table-column prop="operationUserName" label="操作人"/>
                        </el-table>
                        <!-- 分页 -->
                        <div style="margin-top: 10px;text-align:right;padding-right:18px">
                            <el-pagination
                                    background @current-change="curPageChange6"
                                    layout="prev, pager, next"
                                    :total="total6" :page-size="limit6" :current-page="curPage6">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
        <!-- 检查和检测的弹窗 -->
        <el-dialog
                :title="detailObj.oprationStatus === 1 ? '检查' : '检测'"
                :visible.sync="dialogVisible"
                width="30%"
                :before-close="closeDia">
            <div>
                <div v-if="detailObj.oprationStatus === 1" class="examineDiaBox">
                    <div>检查部门：{{ detailObj.examineDepName }}</div>
                    <div>检查指标：{{ detailObj.examineIndicator }}</div>
                    <div>预警值：{{ detailObj.prewarningValue }}</div>
                    <div>联锁值：{{ detailObj.interlockingValue }}</div>
                </div>
                <el-form :model="diaForm1" label-width="80px" size="small">
                    <el-form-item :label="detailObj.oprationStatus === 1 ? '检查内容' : '检测内容'">
                        <el-input v-model="diaForm1.examineContent" type="textarea" :rows="3"/>
                    </el-form-item>
                    <el-form-item :label="detailObj.oprationStatus === 1 ? '检查结果' : '检测结果'">
                        <el-input v-model="diaForm1.examineResult" type="textarea" :rows="3"/>
                    </el-form-item>
                    <el-form-item :label="detailObj.oprationStatus === 1 ? '检查状态' : '检测状态'">
                        <el-radio-group v-model="diaForm1.examineStatus" size="small">
                            <el-radio-button label="正常"></el-radio-button>
                            <el-radio-button label="异常"></el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="closeDia" size="small">取 消</el-button>
        <el-button type="primary" @click="submitDia" size="small">确 定</el-button>
      </span>
        </el-dialog>
        <!-- 操作的弹窗 -->
        <el-dialog
                title="操作"
                :visible.sync="operationVisible"
                width="30%"
                :before-close="closeOpDia">
            <div>
                <el-form :model="operationForm" label-width="80px" size="small">
                    <el-form-item label="分类">
                        <el-select v-model="operationForm.operationType" style="width: 100%">
                            <el-option label="停用" value="停用"/>
                            <el-option label="恢复" value="恢复"/>
                            <el-option label="报废" value="报废"/>
                            <el-option label="维修完成" value="维修完成"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="原因">
                        <el-input v-model="operationForm.reality" type="textarea" :rows="3"/>
                    </el-form-item>
                    <el-form-item label="申请时间">
                        <el-date-picker
                                v-model="operationForm.operationTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="date"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="实际时间">
                        <el-date-picker
                                v-model="operationForm.realTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="date"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="措施">
                        <el-input v-model="operationForm.measures" type="textarea" :rows="3"/>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="closeOpDia" size="small">取 消</el-button>
        <el-button type="primary" @click="submitOperation" size="small">确 定</el-button>
      </span>
        </el-dialog>
        <!-- 预览打印的全屏弹窗 -->
        <el-dialog
                title="打印"
                :visible.sync="fullDia"
                :fullscreen="true"
                @close="fullDiaClose">
            <div class="fullDiaInner" id="fullDiaInner">
                <el-table :data="fullDiaTableData" style="width: 100%">
                    <el-table-column prop="number" label="装置设施位号"/>
                    <el-table-column prop="name" label="装置设施名称"/>
                    <el-table-column prop="shouldRoutingInspection" label="应巡检（次）"/>
                    <el-table-column prop="alreadyRoutingInspection" label="已巡检（次）"/>
                    <el-table-column prop="unRoutingInspection" label="未巡检（次）"/>
                    <el-table-column label="巡检人">
                        <template slot-scope="{ row }">
                            <div v-if="row.checkingPeoples && row.checkingPeoples.length > 0">
                <span v-for="(item, index) in row.checkingPeoples" :key="item.userId">
                  <span v-if="index !== (row.checkingPeoples.length - 1)">{{ item.name }}，</span>
                  <span v-else>{{ item.name }}</span>
                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="abnormalStatus" label="有无异常"/>
                    <el-table-column prop="routingInspectionTime" label="时间"/>
                </el-table>
            </div>
            <span slot="footer" class="fullDiaFoot">
        <el-button size="small" @click="fullDiaClose">取 消</el-button>
        <el-button size="small" type="primary" v-print="printObj">打 印</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        equipmentType, addType, editType, deleteType, getTypeList, getAlluser, deleteEquipment, equipmentInfo,
        equipmentXjRecord, equipmentByRecord, examineAdd, detectionAdd, operationAdd, equipmentExamineList,
        detectionList, operationList, equipmentStatistics, equipmentPrintf
    } from "@/api/processManager"
    import {downLoadDocument} from "@/api/downLoad"

    export default {
        name: 'ProcessMaintenanceRecord',
        data() {
            return {
                typeArr: [], // 分类的数组
                checkType: 0, // 默认选中的分类
                tableData: [],
                // 主页表格的分页数据
                totalType: 0,
                limitType: 10,
                curPageType: 1,
                equipmentId: '', //设备的id
                // 抽屉的数据
                drawerObj: {}, // 存放抽屉表头的数据，不直接从列表拿数据是因为通知人存的是id
                detailObj: {}, // 详情数据
                activeName: "0",
                drawer: false,
                // 抽屉巡检记录的数据
                tableData2: [],
                total2: 0,
                limit2: 10,
                curPage2: 1,
                // 抽屉保养维修记录的表格数据
                tableData3: [],
                total3: 0,
                limit3: 10,
                curPage3: 1,
                // 检查记录
                tableData4: [],
                total4: 0,
                limit4: 10,
                curPage4: 1,
                // 检测记录
                tableData5: [],
                total5: 0,
                limit5: 10,
                curPage5: 1,
                // 操作记录
                tableData6: [],
                total6: 0,
                limit6: 10,
                curPage6: 1,
                // 检测检测的弹窗状态
                dialogVisible: false,
                diaForm1: {
                    examineContent: '',
                    examineResult: '',
                    examineStatus: '正常'
                },
                // 操作记录的数据
                operationVisible: false,
                operationForm: {
                    operationType: '',
                    reality: '',
                    operationTime: '',
                    realTime: '',
                    measures: ''
                },
                statisticsObj: {},
                // 全屏弹窗/打印的弹窗
                fullDia: false,
                fullDiaTableData: [],
                printObj: {
                    id: 'fullDiaInner',
                    popTitle: '',
                    extraCss: 'https://www.google.com,https://www.google.com',
                    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>,<style> #fullDiaInner { height: auto !important; width: 1020px !important } <style>'
                },
                timeRange: []
            }
        },
        // 过滤器
        filters: {
            changeStr(val) {
                return val.toString()
            },
        },
        created() {
            // this.getEquipmentType()
            equipmentType().then(res => {
                this.typeArr = res.body.data
                if (res.body.data.length !== 0) {
                    this.$nextTick(() => {
                        this.checkType = res.body.data[0].id
                    })
                }
                equipmentStatistics().then(res => {
                    this.statisticsObj = res.body.data

                })
                this.getTypeList1(res.body.data[0].id)
            })
        },
        methods: {
            // 分类的弹窗
            classDia(val) {
                let title = ''
                if (val === 0) {
                    title = '添加分类'
                } else {
                    title = '编辑分类'
                }
                this.$prompt('请输入分类名称', `${title}`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({value}) => {
                    if (!value) {
                        this.$message.error('分类名称不能为空')
                        return
                    } else {
                        //添加
                        if (val === 0) {
                            addType({name: value}).then(res => {
                                this.getEquipmentType()
                            })
                        } else {
                            //编辑
                            editType({name: value, id: this.checkType}).then(res => {
                                this.getEquipmentType()
                            })
                        }
                    }
                }).catch(() => {
                    return
                });
            },
            // 添加分类
            addClass() {
                this.classDia(0)
            },
            // 选中分类
            selectType(val) {
                this.checkType = val
                this.getTypeList1(val)
            },
            // 获取分类
            getEquipmentType() {
                equipmentType().then(res => {
                    this.typeArr = res.body.data
                    if (res.body.data.length !== 0) {
                        this.$nextTick(() => {
                            this.checkType = res.body.data[0].id
                        })
                    }
                })
            },
            // 编辑分类
            editClass() {
                this.classDia(1)
            },
            // 删除分类
            delectClass() {
                this.$confirm('删除此分类, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteType(this.checkType).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getEquipmentType()
                    })
                }).catch(() => {
                    return
                });
            },

            // 获取某个分类的列表
            getTypeList1(val) {
                getTypeList({
                    limit: this.limitType,
                    curPage: this.curPageType,
                    equipmentTypeId: val,
                    isPage: 1
                }).then(res => {
                    this.tableData = res.body.data
                    this.totalType = res.body.cum
                })
            },
            // 添加设备按钮
            addEquipmentBtn() {
                this.$router.push({
                    path: '/processManager/AddMaintenanceRecord'
                })
            },
            // 编辑设备按钮
            editEquipmentBtn(row) {
                let obj = {...row}
                for (let i in obj) {
                    if (!obj[i] && obj[i] !== 0 && obj[i] !== '0') {
                        delete obj[i]
                    }
                }
                this.$router.push({
                    name: 'AddMaintenanceRecord',
                    params: {key: {...obj}}
                })
            },
            // 删除设备
            deleteEquipmentBtn(row) {
                // console.log(row)
                this.$confirm(`删除设备 "${row.name}", 是否继续?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteEquipment(row.id).then(res => {
                        if (this.tableData.length <= 1 && this.curPageType > 1) {
                            this.curPageType -= 1
                        }
                        this.getTypeList1(this.checkType)
                        this.$message.success('删除成功')
                    })
                }).catch(() => {
                    return
                });
            },
            // 抽屉关闭
            handleClose() {
                this.drawer = false
                this.timeRange = []
            },
            // 获取巡检记录
            getXjList(id) {
                equipmentXjRecord({equipmentID: id, curPage: this.curPage2, limit: this.limit2}).then(res => {
                    // console.log('巡检记录：'+ res)
                    this.tableData2 = res.body.data
                    this.total2 = res.body.cum
                })
            },
            // 获取设备维修记录
            getWxList(id) {
                equipmentByRecord({equipmentID: id, curPage: this.curPage3, limit: this.limit3}).then(res => {
                    // console.log('维修保养：'+ res)
                    this.tableData3 = res.body.data
                    this.total3 = res.body.cum
                })
            },
            // 获取检查记录
            getJc1List(id) {
                equipmentExamineList({
                    equipmentId: id,
                    curPage: this.curPage4,
                    limit: this.limit4,
                    isPage: 1
                }).then(res => {
                    this.tableData4 = res.body.data
                    this.total4 = res.body.cum
                })
            },
            // 获取检测记录
            getJc2List(id) {
                detectionList({equipmentId: id, curPage: this.curPage5, limit: this.limit5, isPage: 1}).then(res => {
                    this.tableData5 = res.body.data
                    this.total5 = res.body.cum
                })
            },
            // 获取操作记录
            getCzList(id) {
                operationList({equipmentId: id, curPage: this.curPage6, limit: this.limit6, isPage: 1}).then(res => {
                    this.tableData6 = res.body.data
                    this.total6 = res.body.cum
                })
            },
            // 点击编号打开抽屉
            openDrawer(row) {
                this.equipmentId = row.id
                // 获取设备详情
                // equipmentInfo(row.id).then(res => {
                //   this.drawerObj = {...res.body.data}
                // })
                this.getXjList(row.id)
                this.getWxList(row.id)
                this.getJc1List(row.id)
                this.getJc2List(row.id)
                this.getCzList(row.id)
                this.drawer = true
                this.detailObj = row
            },

            // 分页的事件
            curPageChange1(val) {
                this.curPageType = val
                this.getTypeList1(this.checkType)
            },
            curPageChange2(val) {
                this.curPage2 = val
                this.getXjList(this.equipmentId)
            },
            curPageChange3(val) {
                this.curPage3 = val
                this.getWxList(this.equipmentId)
            },
            curPageChange4(val) {
                this.curPage4 = val
                this.getJc1List(this.equipmentId)
            },
            curPageChange5(val) {
                this.curPage5 = val
                this.getJc2List(this.equipmentId)
            },
            curPageChange6(val) {
                this.curPage6 = val
                this.getCzList(this.equipmentId)
            },
            // 检查按钮的事件
            examinBtn(row, status) {
                this.detailObj = {...row, oprationStatus: status}
                this.dialogVisible = true
            },
            closeDia() {
                this.dialogVisible = false
                this.diaForm1 = {
                    examineContent: '',
                    examineResult: '',
                    examineStatus: '正常'
                }
            },
            submitDia() {
                // 检查
                if (this.detailObj.oprationStatus === 1) {
                    examineAdd({...this.diaForm1, equipmentId: this.detailObj.id}).then(res => {
                        this.$message.success('操作成功')
                        this.getTypeList1(this.checkType)
                        this.closeDia()
                    })
                }
                // 检测
                if (this.detailObj.oprationStatus === 2) {
                    let obj = {
                        detectionContent: this.diaForm1.examineContent,
                        detectionResult: this.diaForm1.examineResult,
                        detectionStatus: this.diaForm1.examineStatus,
                        equipmentId: this.detailObj.id
                    }
                    detectionAdd(obj).then(res => {
                        this.$message.success('操作成功')
                        this.getTypeList1(this.checkType)
                        this.closeDia()
                    })
                }
            },
            // 操作按钮的事件
            operationBtn(row) {
                this.detailObj = row
                this.operationVisible = true
            },
            // 弹窗关闭
            closeOpDia() {
                this.operationVisible = false
                this.operationForm = {
                    operationType: '',
                    reality: '',
                    operationTime: '',
                    realTime: '',
                    measures: ''
                }
            },
            // 操作提交
            submitOperation() {
                operationAdd({...this.operationForm, equipmentId: this.detailObj.id}).then(res => {
                    this.$message.success('操作成功')
                    this.closeOpDia()
                    this.getTypeList1(this.checkType)
                })
            },


            // 全屏弹窗的事件（打印）
            // 打开弹窗
            openFullDia() {
                let obj = {id: this.equipmentId}
                if (this.timeRange.length > 0) {
                    obj.startTime = this.timeRange[0]
                    obj.endTime = this.timeRange[1]
                }
                equipmentPrintf(obj).then(res => {
                    this.fullDia = true
                    this.fullDiaTableData = res.body.data
                })
            },
            fullDiaClose() {
                this.fullDia = false
            },
            fullDiaSure() {
                console.log(111)
            },

            // 下载使用说明
            downloadFile(url, name) {
                downLoadDocument(url, name)
            }
        }
    }
</script>

<style scoped>
    .head {
        display: flex;
        justify-content: space-between
    }

    .addBtn {
        /* width: 100px !important; */
        /* position: absolute;
        top: 10px;
        right: -200px; */
    }

    .line {
        margin: 0 3px;
        color: #f2f2f2
    }

    .bodyBox {
        width: 100%;
        height: calc(100vh - 120px);
        display: flex;
        justify-content: space-between;
    }

    .bodyLeft {
        width: 241px;
        height: 100%;
        background: white;
    }

    .bodyLeft::-webkit-scrollbar {
        display: none;
    }

    .detailBox {
        padding: 15px
    }

    .leftTitle {
        display: flex;
        justify-content: space-between;
        padding: 10px 15px 10px 20px;
        font-size: 16px;
    }

    .leftBody {
        /* height: 465px; */
        height: calc(100% - 305px);
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .leftBody::-webkit-scrollbar {
        display: none;
    }

    .leftFoot {
        width: 100%;
        height: 300px;
        border-top: 1px solid #f2f2f2;
    }

    .leftFoot > div {
        color: #515a61;
        font-size: 16px;
        line-height: 30px;
        padding-left: 15px;
    }

    .examineDiaBox {
        padding-left: 10px;
        margin-bottom: 25px
    }

    .examineDiaBox > div {
        font-size: 15px;
        line-height: 30px
    }

    .bodyRight {
        width: calc(100% - 265px);
        /* height: 850px; */
        height: 100%;
        background: white;
        overflow: scroll;
        padding: 10px
    }

    /* 全屏弹窗-打印 */
    .fullDiaInner {
        width: 1020px;
        margin: auto;
        page-break-before: always;
    }

    .fullDiaFoot {
        position: fixed;
        right: 15px;
        bottom: 15px
    }

    /* <!--         抽屉样式           --> */
    .drawerTitle {
        box-shadow: 0px 5px 5px -5px black;
        height: 120px;
        padding-left: 15px;
    }

    .drawerTitle > p {
        color: #000000;
        font-size: 18px;
        line-height: 55px;
    }

    .drawerTitle > p > i {
        font-size: 30px;
        float: right;
        margin: 15px 10px 0 0;
    }

    .drawerTitle > p > i:hover {
        color: #409EFF
    }

    .el-drawer__header {
        padding: 0;
        margin-bottom: 0
    }

    /* 解决tab切换会有蓝色边框的问题 */
    .maintenanceRecordBox /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
        box-shadow: none;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
    }

    .tWord {
        display: flex
    }

    .tWord div > p {
        font-size: 15px;
        line-height: 25px
    }

    .tWord div > span {
        color: #000000
    }

    .tWord div {
        width: 220px
    }

    .drawerBody {
        width: 100%;
        height: calc(100vh - 170px);
        background: rgb(247, 247, 247);
        overflow: hidden;
        padding: 10px 20px 20px;
    }

    .bodyInner {
        background: white;
        height: calc(100% - 50px);
        width: 100%;
        border: 1px solid #eaeaea;
        overflow: scroll;
    }

    .detail {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .detail div {
        width: 50%;
        font-size: 16px;
        line-height: 40px;
        font-weight: 500;
        color: #555555;
    }

    .detail > div > span {
        color: #888888;
    }
</style>
